import style from "./CourseTabs.module.css";

import AboutCourseSection from "@/features/video/components/aboutCourseSection/AboutCourseSection";
import ReviewSection from "@/features/reviews/ReviewSection";
import CommentSection from "@/features/comments/components/commentSection/CommentSection";
import TranscriptSection from "@/features/video/components/transcriptSection/TranscriptSection";
import AskAiButton from "@/features/ai/components/askAiButton/AskAiButton";
import ContentTable from "@/features/video/components/contentTable/ContentTable"; // Import ContentTable

import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { useMediaQuery } from "@/hooks/useMediaQuery"; // Import useMediaQuery

function CourseTabs({ unit, currentVideoSecond, onVideoTimeChange, children }) {
	const { t } = useTranslation();
	const location = useLocation();
	const [activeTab, setActiveTab] = useState(0);
	const isMobile = useMediaQuery("(max-width: 1000px)"); // Use useMediaQuery to check for mobile device

	let tabs = [];

	if (isMobile) {
		tabs = [
			{
				title: t("courses:tabs.content"),
				content: <ContentTable embedded />,
				path: "content",
			},
			{
				title: t("courses:tabs.about"),
				content: <AboutCourseSection unit={unit} />,
				path: "about",
			},
			{
				title: t("courses:tabs.reviews"),
				content: <ReviewSection course={unit?.course} />,
				path: "reviews",
			},
			{
				title: t("courses:tabs.comments"),
				content: <CommentSection video={unit.video} />,
				path: "questions",
			},
			...(unit?.video?.subtitles
				? [
						{
							title: t("courses:tabs.transcript"),
							content: (
								<TranscriptSection
									video={unit.video}
									currentVideoSecond={currentVideoSecond}
									onVideoTimeChange={onVideoTimeChange}
								/>
							),
							path: "transcript",
						},
					]
				: []),
		];
	} else {
		tabs = [
			{
				title: t("courses:tabs.about"),
				content: <AboutCourseSection unit={unit} />,
				path: "about",
			},
			{
				title: t("courses:tabs.reviews"),
				content: <ReviewSection course={unit?.course} />,
				path: "reviews",
			},
			{
				title: t("courses:tabs.comments"),
				content: <CommentSection video={unit.video} />,
				path: "questions",
			},
			...(unit?.video?.subtitles
				? [
						{
							title: t("courses:tabs.transcript"),
							content: (
								<TranscriptSection
									video={unit.video}
									currentVideoSecond={currentVideoSecond}
									onVideoTimeChange={onVideoTimeChange}
								/>
							),
							path: "transcript",
						},
					]
				: []),
		];
	}

	useEffect(() => {
		const path = location.hash.replace("#", "");
		const tabIndex = tabs.findIndex((tab) => tab.path === path);
		if (tabIndex !== -1) {
			setActiveTab(tabIndex);
		}
	}, [location.hash, tabs]);

	const handleTabClick = (index) => {
		setActiveTab(index);
	};

	return (
		<div className={style.tabs}>
			<div className={style.toolbar}>
				<Swiper
					direction="horizontal"
					slidesPerView="auto"
					slidesPerGroup={1}
					pagination={{ clickable: true }}
					scrollbar={{
						draggable: true,
					}}
					mousewheel={true}
					className={style.navigation}
				>
					{tabs.map((tab, index) => (
						<SwiperSlide key={index}>
							<Link
								className={`${style.tabHeader} ${
									activeTab === index ? style.active : ""
								}`}
								onClick={() => handleTabClick(index)}
								to={`#${tab.path}`}
							>
								{tab.title}
							</Link>
						</SwiperSlide>
					))}
				</Swiper>
				<AskAiButton currentUnit={unit} />
			</div>
			{children}
			<div className={style.tabContent}>
				{tabs.map(
					(tab, index) =>
						activeTab === index && (
							<div key={index}>{tab.content}</div>
						)
				)}
			</div>
		</div>
	);
}

export default CourseTabs;
